import CryptoJS from 'crypto-js'


/**
 * Encrypts a query string using AES-256 encryption
 * @param queryString - The URL query string to encrypt (e.g., "from=DXB&to=DEL&adults=1")
 * @returns Encrypted and URL-encoded string
 * @throws Error if encryption fails
 */
export const encryptQueryString = (queryString: string): string => {
    try {
        // Encrypt the query string using AES
        const encrypted = CryptoJS.AES.encrypt(queryString, process.env.NEXT_PUBLIC_SEARCH_ENCRYPTION_KEY || "").toString()
        const signature = CryptoJS.HmacSHA256(encrypted, process.env.NEXT_PUBLIC_SEARCH_ENCRYPTION_KEY || "").toString();
        // URL-safe encoding to handle special characters in encrypted string
        const encodedData = encodeURIComponent(encrypted);
        const encodedSignature = encodeURIComponent(signature);
        return `${encodedData}:${encodedSignature}`;
    } catch (error) {
        throw new Error('error occurred');
    }
}